import React from 'react';
import { InputNumberProps } from 'antd';
import { useCalculateReturnOfInvestments } from '@/context/CalculatorReturnOfInvestment';
import * as S from '../../styles';

export function InputNumberForm(props: Readonly<InputNumberProps>) {
	const { onKeyDown } = useCalculateReturnOfInvestments();

	return <S.CustomInputNumber {...props} onKeyDown={onKeyDown} />;
}
